export const Timezones = {
  UTC: 'UTC',
  AR: 'America/Argentina/Buenos_Aires',
  BR: 'America/Sao_Paulo',
  CL: 'America/Santiago',
  MX: 'America/Mexico_City',
  PL: 'Poland',
  TR: 'Turkey',
  US: 'America/Los_Angeles',
  XX: 'SUT Timezone',
  CO: 'America/Bogota',
  GT: 'America/Guatemala',
}

const getDefaultCountryCode = () => {
  return sessionStorage.getItem('countryCode') || import.meta.env.VITE_COUNTRY_CODE || 'MX'
}

export const getTimezoneByCountryCode = (countryCode = getDefaultCountryCode()) => {

  return Timezones[countryCode]
}